<template>
    <div class="w-full h-full relative" :class="hideOverflow ? 'overflow-hidden' : ''">
        <div class="absolute left-1/3 w-2/3 h-full">            
            <DeviceWrapper :allowViewImage="false" deviceType="desktop" :width="kioskRotations[props.sceneIndex].width"
                :x="kioskRotations[props.sceneIndex].x" :y="kioskRotations[props.sceneIndex].y"
                :z="kioskRotations[props.sceneIndex].z">
                <div class="text-white text-2xl font-bold w-full h-full bg-cover bg-center flex items-center justify-center"
                    :style="{ backgroundImage: backgroundImages[props.sceneIndex] }">
                    <div class="relative place-self-center row-span-full col-start-1 w-32 h-32">
                        <span
                            class="anim-el animate-[ping_2s_ease-in-out_infinite] absolute h-full w-full bg-white z-0 opacity-20 transition-all duration-800"
                            :style="tapStyles[props.sceneIndex]"></span>
                        <span
                            class="anim-el animate-[ping_2s_ease-in-out_infinite] [animation-delay:_0.24s] absolute h-full w-full bg-white opacity-30 z-0 transition-all duration-800"
                            :style="tapStyles[props.sceneIndex]"></span>
                        <div class="flex flex-col 6 text-center items-center justify-center text-white aspect-square w-full relative z-10 overflow-hidden transition-all duration-800 rounded-full"
                            :style="tapStyles[props.sceneIndex]">
                            <p
                                class="text-sm opacity-90 font-bold uppercase tracking-wider leading-none pointer-events-none overflow-hidden">
                                Tap to<br />Start
                            </p>
                        </div>
                    </div>
                </div>
            </DeviceWrapper>
        </div>

        <div class="absolute top-0 left-0 w-1/2 h-full">
            <div :style="badgeStyles"
                class="bg-gray-800 w-2/3 left-12 top-1/2 -translate-y-1/2 absolute bg-w 
                hite transition-all duration-800 rounded shadow-2xl">
                <ImageWrapper :imageSrc="badgeImages[props.sceneIndex]" :aspectRatio="aspectRatios[props.sceneIndex]" />
            </div>
        </div>

    </div>
</template>

<script setup>
import { computed } from 'vue';
import ImageWrapper from './ImageWrapper.vue';
import DeviceWrapper from './DeviceWrapper.vue';

import badge1 from '@/images/screenshots/web/theme-1-badge.png';
import badge2 from '@/images/screenshots/web/theme-2-badge.png';
import badge3 from '@/images/screenshots/web/theme-3-badge.png';

import background1 from '@/images/screenshots/web/theme-1-background.jpg';
import background2 from '@/images/screenshots/web/theme-2-background.jpg';
import background3 from '@/images/screenshots/web/theme-3-background.jpg';

const props = defineProps({
    sceneIndex: {
        type: Number,
        required: true
    },
    hideOverflow: {
        type: Boolean,
        default: true
    }
})

const backgroundImages = [`url(${background1})`, `url(${background2})`, `url(${background3})`]

const tapStyles = [
    'border-radius: 50%; background-color:#FFF; color: #ed1a79;',
    'border-radius: 0%; background-color: #e8c336; color: #1b324c;',
    'border-radius: 25%; background-color: #00093e;'
]

const aspectRatios = [
    '298/420',
    '298/213',
    '298/420'
]

const rotations = [
    "perspective(1000px) rotateX(0deg) rotateY(22deg) rotateZ(0deg)",
    "perspective(1000px) rotateX(0deg) rotateY(1deg) rotateZ(0deg)",
    "perspective(1000px) rotateX(0deg) rotateY(35deg) rotateZ(0deg)"
];

const kioskRotations = [
    {
        x: 5,
        y: -5,
        z: 0,
        width: 100
    },
    {
        x: 10,
        y: -25,
        z: 0,
        width: 100
    },
    {
        x: 10,
        y: -15,
        z: 0,
        width: 100
    }
];

const badgeImages = [badge1, badge2, badge3]

const badgeStyles = computed(() => {
    return {
        transform: rotations[props.sceneIndex],
        aspectRatio: aspectRatios[props.sceneIndex]
    }
})

</script>